<template>
  <v-dialog :model-value="modelValue" max-width="460" @update:model-value="$emit('update:modelValue', $event)">
    <v-card prepend-icon="mdi-email-clock-outline" title="Daily task email">
      <v-card-text>
        <div class="text-body-2 text-grey mb-3">
          <span v-if="employee">{{ employee.fullname }}</span>
        </div>
        <v-alert
          v-if="offered && !enabled"
          type="info"
          variant="tonal"
          density="compact"
          class="mb-3"
          icon="mdi-email-clock-outline"
        >
          Your department set up a daily task email at {{ time }}. Turn it on below to start receiving it each morning.
        </v-alert>
        <v-switch
          v-model="enabled"
          color="primary"
          density="compact"
          hide-details
          :label="enabled ? 'Emailing my daily tasks' : 'Daily task email off'"
        ></v-switch>
        <v-text-field
          v-model="time"
          type="time"
          label="Send time (server time)"
          density="compact"
          variant="outlined"
          prepend-inner-icon="mdi-clock-outline"
          class="mt-3"
          :disabled="!enabled"
          hint="A digest of your due/overdue tickets is sent at this time each day."
          persistent-hint
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="Close" variant="plain" @click="$emit('update:modelValue', false)"></v-btn>
        <v-btn color="primary" text="Save" variant="flat" :loading="saving" @click="save()"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import constant from '@/constant';
import utils from '@/utils';
import apiMixin from '@/mixins/apiMixin';

export default {
  name: 'TaskEmailSettings',
  mixins: [apiMixin],
  props: {
    modelValue: { type: Boolean, default: false },
    employee: { type: Object, default: null },
  },
  emits: ['update:modelValue', 'saved', 'toggle-message'],
  data() {
    return {
      constant,
      enabled: false,
      time: '08:30',
      offered: false,
      saving: false,
    };
  },
  watch: {
    modelValue(open) {
      if (open && this.employee) {
        this.enabled = !!this.employee.email_daily_tasks;
        this.time = (this.employee.daily_tasks_time || '08:30').slice(0, 5);
        this.offered = !!this.employee.daily_tasks_offered;
      }
    },
  },
  methods: {
    save() {
      if (!this.employee || !this.employee.id) return;
      this.saving = true;
      const payload = {
        id: this.employee.id,
        email_daily_tasks: this.enabled,
        daily_tasks_time: this.time || '08:30',
      };
      axios.post(utils._api(this.constant.update_task_email_prefs), payload, this.authHeaders())
        .then((response) => {
          this.saving = false;
          this.$emit('saved', payload);
          this.$emit('toggle-message', response.data.message || 'Saved');
          this.$emit('update:modelValue', false);
        })
        .catch((error) => {
          this.saving = false;
          console.error('Error saving task email prefs:', error);
          this.$emit('toggle-message', 'Failed to save task email setting');
        });
    },
  },
};
</script>
